import {useQuery} from 'react-query';
import {getUserPromotedAdverstisment} from '.';

interface IUseGetUserPromotedAdverstismentProps {
  guid?: string;
}
const useGetUserPromotedAdverstisment = ({
  guid,
}: IUseGetUserPromotedAdverstismentProps) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['user-promoted-advertisement', guid],
    queryFn: () => getUserPromotedAdverstisment(guid),
    enabled: guid ? true : false,
  });
  return {
    UserPromotedAdverstismentData: data,
    UserPromotedAdverstismentIsLoading: isLoading,
    refetch,
  };
};

export default useGetUserPromotedAdverstisment;
